/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=1bb114c0&scoped=true"
import script from "./userlist.vue?vue&type=script&lang=js"
export * from "./userlist.vue?vue&type=script&lang=js"
import style0 from "./userlist.vue?vue&type=style&index=0&id=1bb114c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb114c0",
  null
  
)

export default component.exports